import {FolderTypes} from "../../../models/Folder";
import PersonIcon from '@material-ui/icons/Person';
import {SvgIconComponent} from "@material-ui/icons";
import {DocumentTypes} from "../../../models/Document";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";

export enum DocumentStructureItemType  {
	Static,
	Folder,
	Document,
	StaticFolderDef,
	StaticDocumentDef,
	Enitity
}

export type DocumentStructureItem = {
	id?: string
	type?: DocumentStructureItemType
	title?: string
	info?: string
	allowFolders?: boolean
	allowDocuments?: boolean
	allowedDocuments?: DocumentTypes[]
	folderStructure?: DocumentStructureFolder
	entity?: LookupEntities
	entityParentId?: string
	children?: DocumentStructureItem[]
}

export type DocumentStructureFolder = {
	type: FolderTypes
	allowFolders: boolean
	allowDocuments: boolean
	icon?: SvgIconComponent
}

export const documentsStructure: DocumentStructureItem = {
	id: '1733d76d-6d9a-4499-a99b-b4486bdfa847',
	title: 'Dokumenta',
	type: DocumentStructureItemType.Static,
	allowFolders: false,
	allowDocuments: false,
	children: [
		// {
		// 	id: '650a6ece-d86b-4e03-94d3-3e07bd9704d8',
		// 	title: 'PONUDE UL/IZ',
		// 	type: DocumentStructureItemType.Static,
		// 	allowFolders: false,
		// 	allowDocuments: false,
		// 	children: [
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970410',
		// 			title: 'Zahtev za ponudu',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970411',
		// 			title: 'Ponuda',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970412',
		// 			title: 'Revidovana ponuda',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970413',
		// 			title: 'Zapisnik o usvajanju ponude',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		}
		// 	]
		// },
		// {
		// 	id: '650a6ece-d86b-4e03-94d3-3e07bd970420',
		// 	title: 'UGOVORI  POSL/HR UL/IZ',
		// 	type: DocumentStructureItemType.Static,
		// 	allowFolders: false,
		// 	allowDocuments: false,
		// 	children: [
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970414',
		// 			title: 'Predugovor',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970415',
		// 			title: 'Ugovor',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970416',
		// 			title: 'Aneks ugovora',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970417',
		// 			title: 'Instrumenti obezbedjenja',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		}
		// 	]
		// },
		// {
		// 	id: '650a6ece-d86b-4e03-94d3-3e07bd970421',
		// 	title: 'FINANSIJSKA DOKUMENTACIJA UL/IZ',
		// 	type: DocumentStructureItemType.Static,
		// 	allowFolders: false,
		// 	allowDocuments: false,
		// 	children: [
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970415',
		// 			title: 'Predračun',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970416',
		// 			title: 'Račun',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970417',
		// 			title: 'Avansni račun',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970418',
		// 			title: 'Konačni račun',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		},
		// 		{
		// 			id: '650a6ece-d86b-4e03-94d3-3e07bd970419',
		// 			title: 'Devizni račun',
		// 			type: DocumentStructureItemType.Static,
		// 			allowFolders: false,
		// 			allowDocuments: true,
		// 		}
		// 	]
		// },
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb7230',
		// 	title: 'ODLUKE UL/IZ',
		// 	allowFolders: false,
		// 	allowDocuments: true
		// },
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb7231',
		// 	title: 'REŠENJA UL/IZ',
		// 	allowFolders: false,
		// 	allowDocuments: true
		// },
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb7232',
		// 	title: 'TREBOVANJA / SPECIFIKACIJE',
		// 	allowFolders: false,
		// 	allowDocuments: true
		// },
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb7233',
		// 	title: 'SKUPŠTINA',
		// 	allowFolders: false,
		// 	allowDocuments: true
		// },
		// {
		// 	id: '650a6ece-d86b-4e03-94d3-3e07bd9704d1',
		// 	title: 'Kadrovska',
		// 	type: DocumentStructureItemType.Static,
		// 	allowFolders: true,
		// 	allowDocuments: false,
		// 	folderStructure: {
		// 		type: FolderTypes.Employee,
		// 		allowFolders: false,
		// 		allowDocuments: true,
		// 		icon: PersonIcon
		// 	}
		// },
		{
			id: '650a6ece-d86b-4e03-94d3-3e07bd9704d2',
			title: 'Kadrovska',
			type: DocumentStructureItemType.Static,
			allowFolders: false,
			allowDocuments: false,
			children: [
				{
					type: DocumentStructureItemType.Enitity,
					entity: LookupEntities.Departments,
					children: [
						{
							type: DocumentStructureItemType.Enitity,
							entity: LookupEntities.Positions,
							entityParentId: 'departmentId',
							children: [
								{
									type: DocumentStructureItemType.Enitity,
									entity: LookupEntities.Employees,
									entityParentId: 'positionId'
								}
							]
						}
					]
				}
			]
		},
		{
			id: '650a6ece-d86b-4e03-94d3-3e07bd9704d1',
			title: 'Dobavljači',
			type: DocumentStructureItemType.Static,
			allowFolders: false,
			allowDocuments: false,
			children: [
				{
					type: DocumentStructureItemType.Enitity,
					entity: LookupEntities.Customers
				}
			]
		}
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb72a7',
		// 	title: 'Ugovori',
		// 	allowFolders: false,
		// 	allowDocuments: true
		// },
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb72a8',
		// 	title: 'Ugovori 2',
		// 	allowFolders: false,
		// 	allowDocuments: true
		// },
		// {
		// 	id: 'f86b073e-3533-4fad-a5c8-d37567cb72a9',
		// 	title: 'Ulazni računi',
		// 	allowFolders: false,
		// 	allowDocuments: true,
		// 	allowedDocuments: [DocumentTypes.Invoice]
		// },

	]
}
